/* eslint-disable arrow-body-style */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { MenuItem } from '@mui/material';
import React from 'react';
import { Section } from 'src/@types/Course';
import Iconify from 'src/components/Iconify';
import { TableMoreMenu } from 'src/components/table';

export const useCourseSummery = (
  setCurrentSection: (section: Section, index: number) => void,
  onDeleteSection: VoidFunction,
  section: Section,
  sectionIndex: number,
  setExpanded: React.Dispatch<React.SetStateAction<string | false>>,
  SetSectionModalOpen: React.Dispatch<React.SetStateAction<boolean>>

) => {
  const [openMenu, setOpenMenuActions] = React.useState<HTMLElement | null>(null);

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setOpenMenuActions(event.currentTarget);
    
  };

  const handleCloseMenu = (event?: any) => {
    event?.stopPropagation();
    setOpenMenuActions(null);
  };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  const getMenuItem = () => {
    return (
      <TableMoreMenu
        open={openMenu}
        onOpen={handleOpenMenu}
        onClose={handleCloseMenu}
        actions={
          <>
            <MenuItem
              onClick={(e?: any) => {
                setCurrentSection(section, sectionIndex);
                SetSectionModalOpen(true)
                handleCloseMenu(e);
              }}
            >
              <Iconify icon={'eva:edit-fill'} />
              Edit
            </MenuItem>
            <MenuItem
              onClick={(e?: any) => {
                onDeleteSection();
                handleCloseMenu(e);
              }}
              sx={{ color: 'error.main' }}
            >
              <Iconify icon={'eva:trash-2-outline'} />
              Delete
            </MenuItem>
          </>
        }
      />
    );
  };
  return {
    handleChange,
    getMenuItem,
  };
};
